import React from 'react';
import { Switch } from 'react-router-dom';

import { PrivateRoute } from './PrivateRoute';

import { LoginRoutes } from './login';
import { DocumentRoutes } from './document';
import { Main } from 'pages/Main';
import { ControlTower } from 'pages/Dashboard/ControlTower';
import { AOD } from 'pages/Dashboard/AOD';
import { OTD } from 'pages/Dashboard/OTD';
import { GHGProtocol } from 'pages/GHGProtocol';
import { SettingsRoutes } from './settings';

export const Routes: React.FC = () => {
  return (
    <>
      <Switch>
        <PrivateRoute path="/" exact component={Main} />
        <PrivateRoute path="/base/base" exact component={Main} />
        <PrivateRoute path="/control-tower" exact component={ControlTower} />
        <PrivateRoute path="/dashboard/otd" exact component={OTD} />
        <PrivateRoute path="/dashboard/aod" exact component={AOD} />
        <PrivateRoute path="/ghg-protocol" exact component={GHGProtocol} />
      </Switch>
      <LoginRoutes />
      <SettingsRoutes />
      <DocumentRoutes />
    </>
  );
};
